import { render, staticRenderFns } from "./communication-info.vue?vue&type=template&id=60e7afa1"
import script from "./communication-info.vue?vue&type=script&lang=js"
export * from "./communication-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports